<template>
  <div class="order-list">
    <!-- 订单筛选 tabs -->
    <van-tabs v-model="activeTab" sticky>
      <van-tab title="全部"></van-tab>
      <van-tab title="待发货"></van-tab>
      <van-tab title="已发货"></van-tab>
      <van-tab title="已完成"></van-tab>
    </van-tabs>

    <!-- 订单列表 -->
    <div class="order-container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <!-- 单个订单卡片 -->
          <div
            v-for="order,index in orderList"
            :key="index"
            class="order-card"
            @click="$router.push(`/order/detail/${order.id}`)"
          >
            <!-- 订单头部 -->
            <div class="order-header">
              <span>订单号：{{ order.out_trade_no }}</span>
              <van-tag :type="getStatusTagType(order.status)">
                {{ getStatusText(order.status) }}
              </van-tag>
            </div>

            <!-- 商品信息 -->
            <div
              class="goods-item"
            >
              <van-image
                width="80"
                height="80"
                fit="cover"
                :src="goods.image"
              />
              <div class="goods-info">
                <div class="goods-title">{{ order.name }}</div>
                <div class="goods-spec">{{ order.specs }}</div>
                <div class="goods-price">
                  ¥{{ order.price }} x{{ order.quantity }}
                </div>
              </div>
            </div>
            <!-- 订单底部 -->
            <div class="order-footer">
              <div class="total-price">
                共{{ order.goodsList.length }}件 合计：¥{{ order.totalPrice }}
              </div>
              <div class="order-time">{{ order.createTime }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
  
  <script>
import { order_list } from "@/utils/request";
export default {
  data() {
    return {
      activeTab: 0,
      orderList: [],
      loading: false,
      finished: false,
      refreshing: false,
      mockData: [
        {
          id: 1,
          orderNo: "20230615123456",
          status: 2, // 1待发货 2已发货 3已完成
          createTime: "2023-06-15 14:30:22",
          totalPrice: "238.00",
          goodsList: [
            {
              id: 1,
              name: "新款无线蓝牙耳机",
              price: "199.00",
              quantity: 1,
              specs: "白色 | 标准版",
              image: "https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg",
            },
            {
              id: 2,
              name: "手机壳",
              price: "39.00",
              quantity: 2,
              specs: "透明防摔 | iPhone 13",
              image: "https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg",
            },
          ],
        },
      ],
    };
  },
  methods: {
    // 获取订单状态标签类型
    getStatusTagType(status) {
      const map = {
        1: "warning", // 待发货
        2: "primary", // 已发货
        3: "success", // 已完成
      };
      return map[status] || "";
    },

    // 获取订单状态文本
    getStatusText(status) {
      const map = {
        1: "待发货",
        2: "已发货",
        3: "已完成",
      };
      return map[status] || "";
    },

    // 加载数据
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.orderList = [];
          this.refreshing = false;
        }

        // 模拟加载数据
        this.orderList = this.orderList.concat(this.mockData);
        this.loading = false;

        // 数据全部加载完成
        if (this.orderList.length >= 10) {
          this.finished = true;
        }
      }, 1000);
    },

    // 下拉刷新
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
  },
  async mounted() {
    const res = await order_list({
      data: {
        token: localStorage.getItem("auth_token"),
      },
    });
    this.orderList = res.data.data.list
  },
};
</script>
  
  <style scoped>
.order-list {
  background-color: #f7f8fa;
  min-height: 100vh;
}

.order-container {
  padding: 10px;
}

.order-card {
  background: white;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
}

.order-header {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 13px;
  color: #666;
}

.goods-item {
  display: flex;
  padding: 12px;
  border-bottom: 1px solid #f5f5f5;
}

.goods-info {
  flex: 1;
  margin-left: 10px;
}

.goods-title {
  font-size: 14px;
  margin-bottom: 6px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.goods-spec {
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.goods-price {
  font-size: 14px;
  color: #ee0a24;
  text-align: right;
}

.order-footer {
  padding: 12px;
  text-align: right;
}

.total-price {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}

.order-time {
  font-size: 12px;
  color: #999;
}
</style>